<script setup>
const isConfirmationModalOpen = useState('isConfirmationModalOpen', () => false);
const confirmationModalProps = useState('confirmationModalProps', () => {
  return {
    title: '',
    description: '',
    actionLabel: '',
    actionColor: 'blue',
    onAction: () => {},
  };
});

const loading = ref(false);
const buttonAction = async () => {
  loading.value = true;
  await confirmationModalProps.value.onAction();
  loading.value = false;
};
</script>

<template>
  <UDashboardModal
    v-model="isConfirmationModalOpen"
    prevent-close
    :title="confirmationModalProps.title"
    :description="confirmationModalProps.description"
  >
    <template #footer>
      <UButton
        :color="confirmationModalProps.actionColor"
        :label="confirmationModalProps.actionLabel"
        :loading="loading"
        @click="buttonAction"
      />
      <UButton color="white" label="Cancel" @click="isConfirmationModalOpen = false" />
    </template>
  </UDashboardModal>
</template>
